import { ContentPromotionGoalsDialogHeader } from '../ContentPromotionGoalsDialogHeader/ContentPromotionGoalsDialogHeader';
import { ContentPromotionGoalsDialogRow } from '../ContentPromotionGoalsDialogRow/ContentPromotionGoalsDialogRow';
import { Wrapper } from './styles';
import { ContentPromotionGoalsDialogContentProps } from './types';

export const ContentPromotionGoalsDialogContent: React.FC<
    ContentPromotionGoalsDialogContentProps
> = ({ goals, selected, isAllSelected, onSelect, onSelectAll }) => (
    <Wrapper>
        <ContentPromotionGoalsDialogHeader onSelect={onSelectAll} selected={isAllSelected} />
        {goals.map((goal) => (
            <ContentPromotionGoalsDialogRow
                key={goal.id}
                goal={{ id: goal.id, name: goal.name }}
                selected={selected[goal.id]}
                onSelect={(value) => onSelect(goal.id, value)}
            />
        ))}
    </Wrapper>
);
